// frontend/src/features/assistant/assistantSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { askAssistant } from "./assistantThunks.js";

const initialState = {
  // Historial del chat: [{ role: 'user' | 'assistant', content: string }]
  messages: [],
  loading: false,
  error: null,
};

const assistantSlice = createSlice({
  name: "assistant",
  initialState,
  reducers: {
    addUserMessage: (state, action) => {
      state.messages.push({ role: "user", content: action.payload });
    },
    addAssistantMessage: (state, action) => {
      state.messages.push({ role: "assistant", content: action.payload });
    },
    clearAssistantChat: (state) => {
      state.messages = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(askAssistant.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(askAssistant.fulfilled, (state) => {
        state.loading = false;
        // El mensaje final ya se añade desde el componente (Assistant.jsx)
        // usando addAssistantMessage(res.payload.trim())
      })
      .addCase(askAssistant.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload || "Error al contactar con el asistente.";
      });
  },
});

export const {
  addUserMessage,
  addAssistantMessage,
  clearAssistantChat,
} = assistantSlice.actions;

export default assistantSlice.reducer;
